import { useEffect, useState } from "react"
import { getUsuarios } from '../componentes/api.js';
import Modal from '../comun/VentanaModal.jsx'
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import Table from 'react-bootstrap/Table';

const UsuarioLista =(props)=>{
  /**Para cargar los datos de los combos */
  const [integrantes, setIntegrantes] = useState([]);

   /** Para el manejo de la ventana de mensajes modal**/
   const [show, setShow] = useState(false);
   const [msg, setMsg] = useState([]);
   const handleClose = () => setShow(false);

  useEffect(() =>{
    if(props.proyecto!==''){
      cargarUsuarios()
    }
  },[props.proyecto, props.actualizaListado]);

  const cargarUsuarios= async()=>{
    try {
      const response = await getUsuarios({proyecto: props.proyecto, tipoParticipante: props.tipoParticipante})
      setIntegrantes(response.data)
            
    } catch (error) {
      mostrarMsg(["ERROR", "Ocurrio un error al cargar los Participantes del Proyecto", error])
    }
  }

  const mostrarMsg = (msg)=>{
    setMsg(msg)
    setShow(true)
  }

  return(<>
    <div className="container-fluid" id="divTop">
      <div className="row mt-3 mb-3">
        <Stack sx={{ width: '100%' }} spacing={2}>
          <Alert 
            severity="success">
              Las siguientes personas son los usuarios actuales del Proyecto
            </Alert>
        </Stack>
      </div>

      <div className="row mt-2">
        <Table className="table table-hover table-bordered" responsive>
          <thead className="table-primary">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Nombres</th>
              <th scope="col"># Documento</th>
              <th scope="col">Municipio</th>
              <th scope="col">Celular</th>
              <th scope="col">Cargo</th>
              <th scope="col">Auditor</th>
              <th scope="col">Estado</th>
            </tr>
          </thead>
          <tbody>
            {integrantes.map((reg, i)=>{
              return(
              <tr className={reg.Activo==='Inactivo'? "table-danger":""} key={i}>
                <th> {i+1} </th>
                <th> {reg.Nbres} {reg.Apellidos}</th>
                <th> {reg.NoDocumento} </th>
                <th> {reg.NbreMunicipio} </th>
                <th> {reg.Celular} </th>
                <th> {reg.NbreCargo} </th>
                <th> {reg.Auditor} </th>
                <th> {reg.Activo} </th> 
              </tr>
              )
            })}
          </tbody>
        </Table>
      </div>

      <Modal show={show} handleClose={handleClose} msg={msg} />
    </div>
    </>
  )
}

export default UsuarioLista